export default "__VITE_ASSET__CjSqLVlu__"